export const CARGOS_QUE_PODEM_GERAR_CERTIFICADO = ['chanceler', 'secretario', 'veneravel', 'venerável']